import { render } from "./UpcomingEvents.vue?vue&type=template&id=53e5eaa1&ts=true"
import script from "./UpcomingEvents.vue?vue&type=script&lang=ts"
export * from "./UpcomingEvents.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__